import React, { memo } from "react";

import {
  SKELETON_TEXT_HEIGHT,
  SKELETON_INPUT_HEIGHT,
  SkeletonList,
} from "@hl/base-components/lib/Skeleton";
import {
  Group,
  Stack,
  Divider,
  createStyles,
  useMantineTheme,
  Skeleton,
  AppShell,
  Box,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

import { AppHeader } from "../layout/Header";
import { CardView } from "../marketplace-management/Collected";

import UserCollectedListSkeleton from "./UserCollectedListSkeleton";

const useStyles = createStyles((theme) => ({
  appShellMain: {
    paddingLeft: "20px !important",
    paddingRight: "20px !important",
    [theme.fn.largerThan(theme.breakpoints.md)]: {
      paddingLeft: "40px !important",
      paddingRight: "40px !important",
    },
  },
}));

const UserProfileSkeleton = () => {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm - 1}px)`);

  const { classes } = useStyles();

  return (
    <AppShell
      header={<AppHeader />}
      classNames={{ main: classes.appShellMain }}
    >
      <Stack align="center">
        <Skeleton circle height={208} width={208} />
        <Skeleton height={50} width={400} />

        <Group>
          <SkeletonList
            count={3}
            skeleton={<Skeleton height={SKELETON_TEXT_HEIGHT} width={100} />}
          />
        </Group>
        <Skeleton height={SKELETON_TEXT_HEIGHT} width={300} />
      </Stack>

      <Group mt={106} mb="sm">
        <SkeletonList
          count={2}
          skeleton={<Skeleton height={SKELETON_TEXT_HEIGHT} width={100} />}
        />
      </Group>
      <Divider />
      <Box my={30}>
        {!isMobile ? (
          <Group position="apart">
            <Group spacing={"lg"}>
              <Skeleton height={SKELETON_INPUT_HEIGHT} width={100} />
              <Skeleton height={SKELETON_INPUT_HEIGHT} width={460} />
            </Group>
            <Group>
              <Skeleton height={SKELETON_INPUT_HEIGHT} width={81} />
              <Skeleton height={SKELETON_INPUT_HEIGHT} width={208} />
            </Group>
          </Group>
        ) : (
          <Stack spacing={"sm"}>
            <Skeleton height={SKELETON_INPUT_HEIGHT} />
            <Group spacing={"sm"} grow noWrap>
              <Skeleton height={SKELETON_INPUT_HEIGHT} />
              <Skeleton height={SKELETON_INPUT_HEIGHT} />
              <Skeleton height={SKELETON_INPUT_HEIGHT} />
            </Group>
          </Stack>
        )}
      </Box>
      <UserCollectedListSkeleton view={CardView.Default} />
    </AppShell>
  );
};

export default memo(UserProfileSkeleton);
